module.exports = __webpack_public_path__ + "media/images/emblems/Niederoenz-coat_of_arms-57c4bb02abd017b7638d57bfe4cac899.svg";